<template>
  <div>

    <CRow v-for="objs in idp" :key="objs.id" >
      <CCol col="12"  @click="toggleDetails(objs)" >
        <CIcon name="cil-layers" class="mr-2"/> <label class="font-weight-bold mt-1">{{ objs.title.filter(item => { return (item.key === lang)})[0].value }} </label>
      </CCol>

      <CCol col="12" v-if="objs.description.length > 0" @click="toggleDetails(objs)">
        <div v-html="objs.description.filter(item => { return (item.key === lang)})[0].value"></div>
      </CCol>
      <CCol>
        <CDropdownDivider/>
      </CCol>

      <CCol col="12">

<!--        <CCollapse :show="Boolean(objs._toggled)" :duration="collapseDuration">-->
          <CRow v-for="objsLevel in objs.levels" :key="objs.id" class=" ">

            <CCol col="12" >
              <label class="font-weight-bold mt-1 h6">
                <CIcon name="cil-tags" class="mr-2"/> {{ objsLevel.title.filter(item => { return (item.key === lang)})[0].value }}
              </label>
            </CCol>

            <CCol col="12"  v-for="item in objsLevel.item" :key="item.id" class="mt-2">
              <IDPFrom :objs="item" @remove="onRemove" />
            </CCol>
          </CRow>
<!--        </CCollapse>-->
      </CCol>
    </CRow>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import IDPFrom from "@/projects/views/E-Performances/Estimate/components/sub/IDPFrom.vue";

export default {
  name: 'IDPInfomation',
  components: {IDPFrom},
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Individual Development Plan'
    },
    index: {
      type: Number,
      default:0
    },
    idp: {
      type: Object/Array,
      default() {
        return null
      }
    },
  },

  data: function () {
    return {
      collapseDuration: 0,
    }
  },

  mounted() {
  },

  created() {
  },

  beforeDestroy() {
  },

  methods: {
    toggleDetails (item) {
      item._toggled = !item._toggled
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})
    },

    onRemove(value) {
      this.idp = this.idp.map(item => {
        return {
          ...item,
          levels: item.levels.map(level => {
            return {
              ...level,
              item: level.item.filter(litem => litem._id.toString() !== value._id.toString())
            };
          }).filter(level => level.item.length > 0) // กรอง level ที่ไม่มี item
        };
      }).filter(item => item.levels.length > 0); // กรอง item ที่ไม่มี levels

      this.$emit('update', this.idp,this.index )
    }

  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
    })
  },

  watch: {
    lang(value){

    }
  }
}
</script>
<style>

</style>
